import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setBlockFederalFormModal, setChangeScheduleDate, setDownload94xMultiplePdfModal, setDownloadMultiplePDFModal, setDownloadPDFsByReferenceModal, setDownloadPDFsForSelectedPayerModal, setEmailRecipientCopyModal, setExportToExcelForAllPayers, setExportToExcelForSelectedPayersModal, setExportToExcelModal, setFederal94XGridForms, setFederal94xTaxYear, setFederalGridForms, setSendPayerCopyByEmail94xModal, setSendPayerCopyEmailModal, setReferenceNumber, setBlockSubmissionModal, setBlockSubmissionSelectedReference, setStateForms, setPaginationState, setDownloadSingleRowPDFModal, setPaginationState94x, setLoadingState } from "./ManageFederalFormsSlice";
import { PAGE_STATE } from "../../../constants/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import ManageFormsService from "../../../../../services/ManageFormsService";
import GeneralDataService from "../../../../../services/GeneralDataService";
import General from "../../../../../libs/utility/General";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { MANAGE_FEDERAL_FORMS_LOADING_STATES } from "../constants";

export const { getFederalGridData, get94xGridData, get94xTaxYears, view94xPDF, downLoad94xPDFs, getFederalExport, getFederalExportForAllPayers, getFederalExportForSelectedPayer, downloadFedMultiplePDFs, downloadFedPDFsByPayers, downloadFedPDFsByReference, getFederalPDF, blockFederalSubmission, emailToRecipient, changeScheduleData, sendPayerCopyInMail, getStateForms, SendPDFToPortal } = {
    getFederalGridData: (payload) => {
        return {
            type: "FEDERAL_FORMS/GET_FEDERAL_GRID_DATA",
            payload
        }
    },

    get94xGridData: (payload) => {
        return {
            type: "FEDERAL_FORMS/GET_FEDERAL_94X_GRID_DATA",
            payload
        }
    },

    get94xTaxYears: (payload) => {
        return {
            type: "FEDERAL_FORMS/GET_FEDERAL_94X_TAX_YEAR",
            payload
        }
    },

    view94xPDF: (payload) => {
        return {
            type: "FEDERAL_FORMS/VIEW_94_X_PDf",
            payload
        }
    },

    getFederalPDF: (payload) => {
        return {
            type: "FEDERAL_FORMS/GET_FEDERAL_PDF_1099",
            payload
        }
    },

    downLoad94xPDFs: (payload) => {
        return {
            type: "FEDERAL_FORMS/DOWNLOAD_94_X_PDFS",
            payload
        }
    },

    getFederalExportForAllPayers: (payload) => {
        return {
            type: "FEDERAL_FORMS/EXPORT_TO_EXCEL_FOR_ALL_PAYERS",
            payload
        }
    },

    getFederalExport: (payload) => {
        return {
            type: "FEDERAL_FORMS/EXPORT_TO_EXCEL",
            payload
        }
    },

    getFederalExportForSelectedPayer: (payload) => {
        return {
            type: "FEDERAL_FORMS/EXPORT_TO_EXCEL_FOR_SELECTED_PAYERS",
            payload
        }
    },

    downloadFedMultiplePDFs: (payload) => {
        return {
            type: "FEDERAL_FORMS/DOWNLOAD_MULTIPLE_PDFs",
            payload
        }
    },

    downloadFedPDFsByPayers: (payload) => {
        return {
            type: "FEDERAL_FORMS/DOWNLOAD_PDFs_BY_SELECTED_PAYERS",
            payload
        }
    },

    downloadFedPDFsByReference: (payload) => {
        return {
            type: "FEDERAL_FORMS/DOWNLOAD_PDFs_BY_REFERENCE",
            payload
        }
    },

    blockFederalSubmission: (payload) => {
        return {
            type: "FEDERAL_FORMS/BLOCK_FEDERAL_FORM",
            payload
        }
    },

    changeScheduleData: (payload) => {
        return {
            type: "FEDERAL_FORMS/CHANGE_SCHEDULE_DATE",
            payload,
        }
    },

    sendPayerCopyInMail: (payload) => {
        return {
            type: "FEDERAL_FORMS/SEND_PAYER_COPY_IN_EMAIL",
            payload,
        }
    },

    emailToRecipient: (payload) => {
        return {
            type: "FEDERAL_FORMS/EMAIL_TO_RECIPIENTS",
            payload
        }
    },
    getStateForms: (payload) => {
        return {
            type: "FEDERAL_FORMS/GET_STATE_FORMS",
            payload
        }
    },
    SendPDFToPortal: (payload) => {
        return {
            type: "FEDERAL_FORMS/SEND_PDF_TO_PORT",
            payload
        }
    },
}

function* getFederalGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING}))
        
        const { payerId, taxYear, FilterText, PageNumber, PageSize, IsDesc } = action?.payload;

        const params = {
            payer: payerId,
            taxYear,
            FilterText,
            PageNumber: PageNumber || 1,
            PageSize,
            IsDesc
        }

        const response = yield ManageFormsService.getFederalGridData(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            const referenceNumberList = Data.map(form => {
                const obj = { ...form };
                obj.label = form?.ReferenceNumber || "";
                obj.value = form?.ReferenceNumber || "";
                return obj;
            });

            yield put(setReferenceNumber(referenceNumberList))
            Data.map(d => { return { ...d, IsState: d?.StateFilingCompleted === "true" ? true : false } })
            yield put(setFederalGridForms(General.extractDataFromResponseData(response.data)))
            yield put(setPaginationState({ Total: General.extractPaginationTotalFromResponse(response.data) }))
        } else {
            yield put(setFederalGridForms([]))
            yield put(addNotifications({ heading: "Failed to get federal forms", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setFederalGridForms([]))
        yield put(addNotifications({ heading: "Failed to get federal forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* get94xGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_LOADING}))

        const { payerId, taxYear, PageNumber, PageSize } = action?.payload;

        const params = {
            payer: payerId,
            taxYear,
            PageNumber,
            PageSize,
        }

        const response = yield ManageFormsService.get94xGridData(params)

        const { Message, Status } = response?.data;
        const Data = General.extractDataFromResponseData(response?.data)

        if (Status) {
            yield put(setFederal94XGridForms(Data))
            yield put(setPaginationState94x({ Total: General.extractPaginationTotalFromResponse(response?.data) }))
        } else {
            yield put(addNotifications({ heading: "Failed to get federal 94x forms", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get federal 94x forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_READY}))
    }
}

function* get94xTaxYearAsync() {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.TAX_YEARS_LOADING}))

        const response = yield GeneralDataService.get94xTaxYears()

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "ID", "ID")
            yield put(setFederal94xTaxYear(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to get federal 94x tax year", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get federal 94x tax year", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.TAX_YEARS_READY }))
    }
}

function* view94xPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_LOADING}))

        const { payerId, formId, formTypeId } = action.payload

        const response = yield ManageFormsService.view94xPDF({ payerId, formId, formTypeId })

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name)
        } else {
            yield put(addNotifications({ heading: "Failed to get 94x pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get 94x pdf", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_READY }))
    }
}

function* downLoad94xPDFsAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_LOADING }))

        const { payerId, formName, payerName, referenceNo, taxYear, formIds, maskTin = false } = action.payload

        const params = {
            payerId,
            formName,
            formIds,
            payerName,
            referenceNo,
            maskTin: maskTin,
            taxYear,
            IsCorrected: false,
            pdfCopy: "all",
        }

        const response = yield ManageFormsService.downLoad94xPDFs(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, `${Data.Name.split(".")[0]}.zip`)
            yield put(setDownload94xMultiplePdfModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to get 94x pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get 94x pdf", message: error?.response?.data?.Message }));
        yield put(setDownload94xMultiplePdfModal(false))
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS94X_GRID_READY }))
    }
}

function* getFederalExportAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const { payerId, formId, taxYear, formName } = action.payload

        const params = {
            payerId,
            formId,
            taxYear,
            formName: General.removeDashesFromString(formName),
            status: "Submitted",
            formtype: "ManageForms",
        }

        const response = yield ManageFormsService.getFederalExport(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.downloadFileFromBase64(Data.Base64, Data.Name)
            yield put(setExportToExcelModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to get export to excel", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setExportToExcelModal(false))
        yield put(addNotifications({ heading: "Failed to get export to excel", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* getFederalExportForAllPayersAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const { formId, taxYear, formName } = action.payload

        const params = {
            formId,
            taxYear,
            formName: General.removeDashesFromString(formName),
            status: "Submitted",
            formtype: "ManageForms",
        }

        const response = yield ManageFormsService.getFederalExportForAllPayers(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data?.Base64) {
                General.downloadFileFromBase64(Data.Base64, Data.Name)
            }
            yield put(setExportToExcelForAllPayers(false))
        } else {
            yield put(addNotifications({ heading: "Failed to export to excel for all payers", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setExportToExcelForAllPayers(false))
        yield put(addNotifications({ heading: "Failed to export to excel for all payers", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* getFederalExportForSelectedPayerAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const { payerIds, formId, taxYear, formName } = action.payload

        const params = {
            payerIds,
            formId,
            taxYear,
            formName: General.removeDashesFromString(formName),
            status: "Submitted",
            formtype: "ManageForms",
        }

        const response = yield ManageFormsService.getFederalExportForSelectedPayer(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data?.Base64) {
                General.downloadFileFromBase64(Data.Base64, Data.Name)
            }
            yield put(setExportToExcelForSelectedPayersModal(false))
            yield put(addNotifications({ message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to export to excel", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setExportToExcelForSelectedPayersModal(false))
        yield put(addNotifications({ heading: "Failed to export to excel", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* downloadFedMultiplePDFsAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const { payerId, formName, payerName, referenceNo, taxYear, pdfCopy, maskTin, FormIds, mergeCopies = false } = action.payload

        const params = {
            formIds: FormIds,
            payerName,
            payerId,
            referenceNo,
            pdfCopy,
            maskTin,
            formName,
            taxYear,
            sourcePage: "ManageForms",
            isCorrected: false,
            mergeCopies: mergeCopies,
        }

        const response = yield ManageFormsService.downLoadFedMultiplePDFs(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data?.Base64) {
                General.downloadFileFromBase64(Data?.Base64, Data?.Name)
            }
            yield put(addNotifications({ heading: "You request has been processed", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setDownloadMultiplePDFModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to download pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download pdf", message: error?.response?.data?.Message }));
        yield put(setDownloadMultiplePDFModal(false))
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* downloadFedPDFsByPayersAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const { payerId, formName, payerName, taxYear, pdfCopy, maskTin, partNumber, mergeCopies = false } = action.payload

        const params = {
            year: taxYear,
            payerid: payerId,
            payerName,
            formName,
            pdfCopy,
            maskTin,
            mergeCopies
        }

        const response = yield ManageFormsService.downloadFedPDFsByPayers(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data?.Base64) {
                General.downloadFileFromBase64(Data?.Base64, Data?.Name)
            }
            yield put(addNotifications({ heading: "You request has been processed", message: Message, variant: TOASTER_VARIANT.SUCCESS }));       
            yield put(setDownloadPDFsForSelectedPayerModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to download pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download pdf", message: error?.response?.data?.Message }));
        yield put(setDownloadPDFsForSelectedPayerModal(false))
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* downLoadFedPDFsByReferenceAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const { payerId, payerName, pdfCopy, maskTin, referenceNo, formId, mergeCopies = false } = action.payload

        const params = {
            formIds: formId,
            payerName,
            payerId,
            referenceNo,
            pdfCopy,
            maskTin,
            mergeCopies: mergeCopies
        }

        const response = yield ManageFormsService.downloadFedPDFsByReference(params)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if (Data?.Base64) {
                General.downloadFileFromBase64(Data?.Base64, Data?.Name)
            }
            yield put(addNotifications({ heading: "Your request has been processed", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setDownloadPDFsByReferenceModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to download pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to download pdf", message: error?.response?.data?.Message }));
        yield put(setDownloadPDFsByReferenceModal(false))
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* getFederalPDFAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const { payerId, formId, formTypeId, pdfAction = 'all', mergeCopies = false, UnmaskTin = true } = action.payload

        const response = yield ManageFormsService.getFederalPDF({ payerId, formId, formTypeId, pdfAction, UnmaskTin: UnmaskTin, mergeCopies })

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name)
            yield put(setDownloadSingleRowPDFModal(false));
        } else {
            yield put(addNotifications({ heading: "Failed to get pdf", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get pdf", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* blockFederalSubmissionAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }));

        const { referenceNumber, State, formId, formTypeId } = action.payload;

        const response = yield ManageFormsService.blockFederalSubmission(referenceNumber, formId, State, formTypeId);

        const { Data, Message, Status } = response?.data;
        if (Status) {
            yield put(addNotifications({ message: Data, variant: Data == "Blocked Successfully" ? TOASTER_VARIANT.SUCCESS : TOASTER_VARIANT.DANGER}));
            yield put(setBlockFederalFormModal(false))
            yield put(setBlockSubmissionModal(false));
        } else {
            yield put(addNotifications({ heading: "Failed to block federal form", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setBlockFederalFormModal(false))
        yield put(setBlockSubmissionModal(false))
        yield put(addNotifications({ heading: "Failed to block federal form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setBlockSubmissionSelectedReference({ label: "", value: "" }));
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* emailToRecipientAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }));

        const { formIds, taxYear, formName, payerId, AllSelected } = action.payload;

        const response = yield ManageFormsService.emailToRecipient({ formIds, taxYear, formName, payerId, AllSelected });

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Your request has been proceed.", message: Data, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setEmailRecipientCopyModal(false))
        } else {
            yield put(addNotifications({ heading: "Failed to send email", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(setEmailRecipientCopyModal(false))
        yield put(addNotifications({ heading: "Failed to send email", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* changeScheduleDataAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }));

        const { scheduleDate, selectedFederalForms, payerId, taxYear, paginationState } = action.payload;

        if (!selectedFederalForms?.length) {
            yield put(addNotifications({ heading: "Please select a form" }));
            return;
        }

        // // Filtering out the forms with valid future scheduled date. If form has a scheduled date in the past, it should not be sent to the backend.
        // const filteredForms = selectedFederalForms.filter(form => !General.isDateInPast(form?.ScheduleDateString));

        const response = yield ManageFormsService.changeFederalScheduleDate(scheduleDate, selectedFederalForms.map(form => form?.ReferenceNumber).toString());

        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(addNotifications({ message: Data, variant: Data == "You can not schedule this reference number." ? TOASTER_VARIANT.DANGER : TOASTER_VARIANT.SUCCESS }));
            yield put(getFederalGridData({ payerId, taxYear, ...paginationState }))
        } else {
            yield put(addNotifications({ heading: "Failed to change the scheduled data", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to change the scheduled data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setChangeScheduleDate(false))
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }));
    }
}

function* sendPayerCopyInMailAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }));

        const { payerId, taxYear, formName } = action?.payload;

        if (!formName) {
            yield put(addNotifications({ heading: "Please select a form" }));
            return;
        }

        const response = yield ManageFormsService.sendPayerCopyInMail({ payerId, taxYear, formName });

        const { Message, Status } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: "Email has been sent. Please check your email", variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Failed to send a payer copy", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to send payer a copy", message: error?.response?.data?.Message }));
    } finally {
        yield put(setSendPayerCopyEmailModal(false))
        yield put(setSendPayerCopyByEmail94xModal(false))
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }));
    }
}

function* getStateFormsAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))
        
        const response = yield ManageFormsService.getStateForms()

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.addOptionAndValueKeys(Data, "FormName1", "FormId")
            yield put(setStateForms(Data));
        } else {
            yield put(addNotifications({ heading: "Failed to fetch state forms", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch state forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* SendPDFToPortalAsync(action) {
    try {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_LOADING }))

        const data = action.payload
        const response = yield ManageFormsService.sendPdfToPortal(data)

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_FEDERAL_FORMS_LOADING_STATES.FORMS1099_GRID_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFederalGridData().type, getFederalGridDataAsync),
        takeLatest(get94xGridData().type, get94xGridDataAsync),
        takeLatest(get94xTaxYears().type, get94xTaxYearAsync),
        takeLatest(view94xPDF().type, view94xPDFAsync),
        takeLatest(downLoad94xPDFs().type, downLoad94xPDFsAsync),
        takeLatest(getFederalExport().type, getFederalExportAsync),
        takeLatest(getFederalExportForAllPayers().type, getFederalExportForAllPayersAsync),
        takeLatest(getFederalExportForSelectedPayer().type, getFederalExportForSelectedPayerAsync),
        takeLatest(downloadFedMultiplePDFs().type, downloadFedMultiplePDFsAsync),
        takeLatest(downloadFedPDFsByPayers().type, downloadFedPDFsByPayersAsync),
        takeLatest(downloadFedPDFsByReference().type, downLoadFedPDFsByReferenceAsync),
        takeLatest(getFederalPDF().type, getFederalPDFAsync),
        takeLatest(blockFederalSubmission().type, blockFederalSubmissionAsync),
        takeLatest(changeScheduleData().type, changeScheduleDataAsync),
        takeLatest(sendPayerCopyInMail().type, sendPayerCopyInMailAsync),
        takeLatest(emailToRecipient().type, emailToRecipientAsync),
        takeLatest(getStateForms().type, getStateFormsAsync),
        takeLatest(SendPDFToPortal().type, SendPDFToPortalAsync),

    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);